import { render, staticRenderFns } from "./safe-programme-detail.vue?vue&type=template&id=0803e3fe&scoped=true&"
import script from "./safe-programme-detail.vue?vue&type=script&lang=js&"
export * from "./safe-programme-detail.vue?vue&type=script&lang=js&"
import style0 from "./safe-programme-detail.vue?vue&type=style&index=0&id=0803e3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0803e3fe",
  null
  
)

export default component.exports